import React from 'react';

function isStarPoint(boardSize, row, col) {
  row++; // 0-18 -> 1-19
  col++;
  if (boardSize !== 19) {
    return;
  }
  return ((row === 4 || row === 10 || row === 16) &&
    (col === 4 || col === 10 || col === 16));
}

function getStone(props, cx, cy, r) {
  let stone = null;
  if (props.player === 1) { // black
    stone = <circle className="stone black" cx={cx} cy={cy} r={r} />
  } else if (props.player === -1) { // white
    stone = <circle className="stone white" cx={cx} cy={cy} r={r} />
  } else if (props.rank === 1) {
    stone = <circle className="stone cyan" cx={cx} cy={cy} r={r} />
  } else if (props.rank === 2) {
    stone = <circle className="stone green" cx={cx} cy={cy} r={r} />
  } else if (props.rank === 3) {
    stone = <circle className="stone pink" cx={cx} cy={cy} r={r} />
  } else if (props.rank === 4) {
    stone = <circle className="stone orange" cx={cx} cy={cy} r={r} />
  } else if (props.rank === 5) {
    stone = <circle className="stone board" cx={cx} cy={cy} r={r} />
  }
  return stone;
}

function getLastMove(props, cx, cy, r) {
  if (!props.lastMove || props.viewMode === "variation") {
    return null;
  }
  return (
    <rect className="last-move-mark"
      x={cx - r / 2}
      y={cy - r / 2}
      width={r}
      height={r}
    />
  );
}

function formatVisit(props) {
  let visit;
  if (isNaN(props.visit)) {
    visit = null;
  } else if (props.visit >= 100000000) {
    visit = (props.visit / 1000000000).toFixed(1) + "b";
  } else if (props.visit >= 10000000) {
    visit = (props.visit / 1000000).toFixed(0) + "m";
  } else if (props.visit >= 1000000) {
    visit = (props.visit / 1000000).toFixed(1) + "m";
  } else if (props.visit >= 10000) {
    visit = (props.visit / 1000).toFixed(0) + "k";
  } else if (props.visit >= 1000) {
    visit = (props.visit / 1000).toFixed(1) + "k";
  } else {
    try {
      visit = props.visit.toFixed(0);
    } catch (reason) {
      visit = null;
    }
  }
  return visit;
}

function getWinrate(props, width) {
  if (props.viewMode !== "visits") {
    return null;
  }
  const fontSize = width * props.fontSize / 20;
  return (
    (props.rank && props.winRate)
      ? <text x="50%" y="40%" dominantBaseline="middle"
        textAnchor="middle" fontSize={fontSize}>
        {props.winRate.toFixed(1)}
      </text>
      : null
  );
}

function getVisits(props, width) {
  if (props.viewMode !== "visits") {
    return null;
  }
  const fontSize = width * props.fontSize / 25;
  return (
    (props.rank && props.visit)
      ? <text x="50%" y="75%" dominantBaseline="middle"
        textAnchor="middle" fontSize={fontSize}>
        {formatVisit(props)}
      </text>
      : null
  );
}

function getMoveNumber(props, width) {
  if (props.viewMode !== "moveNumber" && props.viewMode !== "variation") {
    return null;
  }
  const fontSize = width * props.fontSize / 18;
  const color = (props.player === 1) ? "white" : "black";
  return (
    props.moveNumber
      ? <text x="50%" y="51%" dominantBaseline="middle"
        textAnchor="middle" fill={color} fontSize={fontSize}>
        {props.moveNumber}
      </text>
      : null
  );
}

function getVariationLetter(props, width) {
  if (props.viewMode !== "variation") {
    return null;
  }
  const fontSize = width * props.fontSize / 12;
  return (
    props.variationLetter
      ? <text x="50%" y="51%" dominantBaseline="middle"
        textAnchor="middle" fill="blue" fontSize={fontSize}
        fontWeight="bold">
        {props.variationLetter}
      </text>
      : null
  );
}

function Square(props) {
  const w = props.width;
  const h = props.height;
  const cx = Math.round(w / 2); // center X
  const cy = Math.round(h / 2); // center Y
  const y1 = (props.row > 0) ? 0 : cy; // vertical y1
  const y2 = (props.row < props.boardSize - 1) ? h : cy; // vertical y2
  const x1 = (props.col > 0) ? 0 : cx; // horizontal x1
  const x2 = (props.col < props.boardSize - 1) ? w : cx; // horizontal x2
  const star = isStarPoint(props.boardSize, props.row, props.col)
    ? <circle className="star" cx={cx} cy={cy} r={w / 12} />
    : null;
  const r = w / 2.075;
  const stone = getStone(props, cx, cy, r);
  const lastMove = getLastMove(props, cx, cy, r / 1.2);

  return (
    <svg className="square" width={w} height={h} onClick={props.onClick}>
      <defs>
        <radialGradient id="blackGradient" cx="75%" cy="25%" r="50%">
          <stop offset="20%" stopColor="#555" />
          <stop offset="95%" stopColor="#111" />
        </radialGradient>
        <radialGradient id="whiteGradient" cx="75%" cy="25%" r="75%">
          <stop offset="20%" stopColor="white" />
          <stop offset="95%" stopColor="lightgray" />
        </radialGradient>
      </defs>

      <rect width={w} height={h} />
      <line x1={cx} y1={y1} x2={cx} y2={y2} />
      <line x1={x1} y1={cy} x2={x2} y2={cy} />
      {star}
      {stone}
      {lastMove}
      {getWinrate(props, w)}
      {getVisits(props, w)}
      {getMoveNumber(props, w)}
      {getVariationLetter(props, w)}
    </svg>
  );
}

export default Square;